import { AtsJobClass } from "src/classes/ats/job";
import { AtsJob } from "src/types/merge_ats";

const Description = ({ job }: { job: AtsJob }) => {
  const J = new AtsJobClass(job);
  return (
    <div className="rounded-lg p-6 border-[1px] border-odfblue-hue w-full h-full overflow-y-scroll">
      <div
        className="bg-white rounded-lg p-4"
        dangerouslySetInnerHTML={{ __html: J.descriptionToHtml() }}
      />
    </div>
  );
};

export default Description;
